import React from "react";
import { ProductScreen, Appbar, useMobileMenu } from "../produits/productMobileKit";
import ShipmentReports from "../../gestion-logistics/reports/ShipmentReports";

export default function LogisticsReportsMobile() {
  const onMenu = useMobileMenu();
  return (
    <ProductScreen>
      <Appbar title="Rapports logistiques" subtitle="Analyses et exports" onMenu={onMenu} />
      <div className="body">
        <ShipmentReports />
      </div>
    </ProductScreen>
  );
}
